import React, { useState, useEffect } from "react";
import { Route, Link, useHistory } from "react-router-dom";

import PropTypes from "prop-types";

import {
  Button,
  Container,
  Typography,
  Avatar,
  useMediaQuery,
  useTheme,
  Dialog,
  CircularProgress,
  Slide,
  Grid,
  AppBar,
  Tabs,
  Tab,
  Fab,
} from "@material-ui/core";

import Masonry from "react-masonry-css";
import SwipeableViews from "react-swipeable-views";

import {
  Person,
  HowToVote,
  ThumbUp,
  PauseCircleOutline,
  CheckCircleOutline,
} from "@material-ui/icons";

import Help from "../../assets/icon/help.svg";

import {
  designContestCollection,
  usersCollection,
  subdomainsCollection,
  webstoreCollection,
} from "../../components/firebase/DataProvider";

import {
  firefunctions,
  useFirebase,
} from "../../components/firebase/FirebaseProvider";

import NotFound from "./../404";
import AppLoading from "../../components/appLoading";

import { useSnackbar } from "notistack";

import DesignDialog from "./designDialog";
import SubmitDialog from "./submitDialog";
import LoginPopup from "./../login/loginPopup";

import { isMobile } from "react-device-detect";

import "./style.css";
import useStyles from "./style";
import { useCollectionData } from "react-firebase-hooks/firestore";
import HelpPopup from "./helpDialog";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const TransitionSlideUp = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const breakpointColumnsObj = {
  default: 3,
  1100: 2,
  768: 1,
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
      style={{
        minHeight: "100vh",
      }}
    >
      {children.length > 0 ? (
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="my-masonry-grid"
          columnClassName="my-masonry-grid_column"
        >
          {value === index && children}
        </Masonry>
      ) : (
        <Typography
          variant="h6"
          component="h6"
          style={{
            textAlign: "center",
            color: "grey",
          }}
        >
          Tidak ada
        </Typography>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const DesignContest = () => {
  const { user } = useFirebase();

  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(768));

  const history = useHistory();

  const { enqueueSnackbar } = useSnackbar();

  const [year] = useState(new Date().getFullYear());

  const [pageIndex, setPageIndex] = React.useState(0);

  const [designContest, setDesignContest] = useState({});
  const [designs, setDesigns] = useState([]);
  const [upvotedDesigns, setUpvotedDesigns] = useState([]);
  const [likedDesigns, setLikedDesigns] = useState([]);
  const [openedDesign, setOpenedDesign] = useState({});

  const [upvotes, setUpvotes] = useState([]);
  const [upvotting, setUpvotting] = useState(false);
  const [upvottingId, setUpvottingId] = useState("");

  const [likes, setLikes] = useState([]);
  const [liking, setLiking] = useState(false);
  const [likingId, setLikingId] = useState("");

  const [isAdmin, setAdmin] = useState(false);
  const [loadingUserInfo, setLoadingUserInfo] = useState(false);

  const [profile, setProfile] = useState({
    name: "",
    subdomain: "",
    avatar: "",
  });

  const handleChangePage = (e, newVal) => {
    setPageIndex(newVal);
  };

  const handleChangePageIndex = (index) => {
    setPageIndex(index);
  };

  const handleApproval = async (id, mode) => {
    try {
      if (window.confirm("Anda Yakin?")) {
        const approve = firefunctions.httpsCallable("design-approve");
        const data = {
          contest_id: designContest.id,
          design_id: id,
          mode
        };

        await approve(data);
      }

      return {
        success: true,
        message: "ok",
      };
    } catch (error) {
      return {
        success: false,
        message: error.message,
      };
    }
  };

  const handleUpvote = async (id, mode) => {
    if (!user) {
      history.push("/fashion-design-competition/login-popup");
      return {
        success: false,
        message: "unauthenticated",
      };
    }

    if (!id || !mode) {
      return {
        success: false,
        message: "desain tidak ditemukan",
      };
    }

    setUpvotting(true);
    setUpvottingId(id);

    try {
      const max_upvote = designContest.data.max_upvote_per_user;
      if (upvotes.length >= max_upvote && upvotes.indexOf(id) < 0) {
        throw new Error(`vote hanya diperbolehkan ${max_upvote} kali!`);
      }

      const upvote = firefunctions.httpsCallable("design-vote");
      const data = {
        mode,
        contest_id: designContest.id,
        design_id: id,
        name: profile.name,
      };

      let newUpvotes = [...upvotes];
      if (mode === "up") {
        newUpvotes.push(id);
      } else {
        newUpvotes.splice(upvotes.indexOf(id), 1);
      }

      setUpvotes(() => newUpvotes);

      await upvote(data);

      setUpvotting(false);
      setUpvottingId("");

      return {
        success: true,
        message: "ok",
      };
    } catch (error) {
      let newUpvotes = [...upvotes];
      const index = upvotes.indexOf(id);

      if (mode === "up") {
        if (index >= 0) {
          newUpvotes.splice(index, 1);
        }
      } else {
        newUpvotes.push(id);
      }

      setUpvotes(() => newUpvotes);

      enqueueSnackbar(error.message, {
        variant: "error",
      });

      setUpvotting(false);
      setUpvottingId("");

      return {
        success: false,
        message: error.message,
      };
    }
  };

  const handleLike = async (id, mode) => {
    if (!user) {
      history.push("/fashion-design-competition/login-popup");
      return {
        success: false,
        message: "unauthenticated",
      };
    }

    if (!id || !mode) {
      return {
        success: false,
        message: "desain tidak ditemukan",
      };
    }

    setLiking(true);
    setLikingId(id);

    try {
      const like = firefunctions.httpsCallable("design-like");
      const data = {
        mode,
        contest_id: designContest.id,
        design_id: id,
        name: profile.name,
      };

      let newLikes = [...likes];
      if (mode === "up") {
        newLikes.push(id);
      } else {
        newLikes.splice(likes.indexOf(id), 1);
      }

      setLikes(() => newLikes);

      await like(data);

      setLiking(false);
      setLikingId("");

      return {
        success: true,
        message: "ok",
      };
    } catch (error) {
      let newLikes = [...likes];
      const index = likes.indexOf(id);

      if (mode === "up") {
        if (index >= 0) {
          newLikes.splice(index, 1);
        }
      } else {
        newLikes.push(id);
      }

      setLikes(() => newLikes);

      enqueueSnackbar(error.message, {
        variant: "error",
      });

      setLiking(false);
      setLikingId("");

      return {
        success: false,
        message: error.message,
      };
    }
  };

  const openDesign = (index, mode) => {
    let design = {};
    if (mode === "liked") {
      design = likedDesigns[index];
    } else if (mode === "voted") {
      design = upvotedDesigns[index];
    } else {
      design = designs[index];
    }
    setOpenedDesign(design);
  };

  const designsContestRef = designContestCollection.where(
    "status",
    "==",
    "active"
  );
  const [dataContestDesign, loadingDataContestDesign] = useCollectionData(
    designsContestRef,
    {
      idField: "id",
    }
  );

  useEffect(() => {
    if (!loadingDataContestDesign) {
      if (dataContestDesign.length > 0) {
        setDesignContest((prev) => {
          const update = {
            id: dataContestDesign[0].id,
            data: dataContestDesign[0],
          };

          return { ...prev, ...update };
        });
      } else {
        setDesignContest({});
      }
    }
  }, [loadingDataContestDesign, dataContestDesign]);

  const designsRef = designContestCollection
    .doc(designContest?.id || "DEFAULT_ID")
    .collection("designs")
    // .where('status', '==', 'approved')
    .orderBy("submitted_at", "desc");

  const [dataDesigns = [], loadingDataDesigns] = useCollectionData(designsRef, {
    idField: "id",
  });

  useEffect(() => {
    if (
      !loadingDataDesigns &&
      dataDesigns.length > 0 &&
      (dataDesigns.length >= designContest.data.min_design_show || isAdmin)
    ) {
      const filterApproved = designContest.data.isVotable && !isAdmin;

      const designs = dataDesigns
        .map((item) => {
          const data = item;

          return {
            designContestId: designContest.id,
            isLikable: designContest.data.isLikable,
            isVotable: designContest.data.isVotable,
            id: item.id,
            images: data.images,
            owner: {
              nama: data.owner_info.name,
              subdomain: data.owner_info.subdomain,
              avatar: data.owner_info.avatar,
              domisili: data.owner_info.domisili,
              profesi: data.owner_info.profession,
              usia: data.owner_info.age,
            },
            title: data.title,
            philosophy: data.philosophy,
            description: data.description,
            submitted_at: data.submitted_at,
            status: data.status,
            isUpvoted: upvotes.indexOf(item.id) >= 0 ? true : false,
            isLiked: likes.indexOf(item.id) >= 0 ? true : false,
          };
        })
        .filter((item) => {
          if (filterApproved) {
            return item.status === "approved";
          } else {
            return item;
          }
        });
      setDesigns(() => designs);

      const upvotedDesigns = designs.filter((item) => item.isUpvoted);
      setUpvotedDesigns(() => upvotedDesigns);

      const likedDesigns = designs.filter((item) => item.isLiked);
      setLikedDesigns(() => likedDesigns);
    }
  }, [loadingDataDesigns, upvotes, likes, dataDesigns, designContest, isAdmin]);

  useEffect(() => {
    if (user) {
      setLoadingUserInfo(true);

      async function userInit() {
        let userInfo = {
          name: "",
          subdomain: "",
          avatar: "",
        };

        const getUpvotes = await usersCollection
          .doc(user.uid)
          .collection("activity")
          .doc("votes")
          .get();
        if (getUpvotes.exists) {
          const dataUpvotes = getUpvotes.data();
          const userUpvotes = dataUpvotes[designContest.id] || [];

          setUpvotes(() => userUpvotes);
        }

        const getLikes = await usersCollection
          .doc(user.uid)
          .collection("activity")
          .doc("likes")
          .get();
        if (getLikes.exists) {
          const dataLikes = getLikes.data();
          const userLikes = dataLikes[designContest.id] || [];

          setLikes(() => userLikes);
        }

        const getUser = await usersCollection.doc(user.uid).get();
        const { nama: name = "" } = getUser.data();
        userInfo.name = name;

        const getSubdomain = await subdomainsCollection
          .where("user_id", "==", user.uid)
          .get();
        if (!getSubdomain.empty) {
          userInfo.subdomain = getSubdomain.docs[0].id;
        }

        const getWebstore = await webstoreCollection.doc(user.uid).get();
        const { logo: avatar = "" } = getWebstore.data();
        userInfo.avatar = avatar;

        setProfile((prev) => {
          return { ...prev, ...userInfo };
        });
      }
      userInit();

      setLoadingUserInfo(false);
    } else {
      setUpvotes([]);
      setLikes([]);
    }
  }, [user, designContest]);

  useEffect(() => {
    if (user && designContest?.data) {
      if (
        designContest.data.admins &&
        designContest.data.admins.indexOf(user.uid) >= 0
      ) {
        setAdmin(true);
      } else {
        setAdmin(false);
      }
    }
  }, [user, designContest?.data]);

  if (loadingDataContestDesign || loadingDataDesigns || loadingUserInfo) {
    return <AppLoading />;
  }

  if (!loadingDataContestDesign && !loadingDataDesigns && !designContest.id) {
    return <NotFound />;
  }

  return (
    <>
      <div
        style={{
          backgroundColor: "white",
        }}
      >
        <div className={classes.banner}>
          <div className={classes.bannerImage}>
            {designContest?.data?.bannerImage ? (
              <img
                src={isMobile || fullScreen ? designContest.data.bannerImage : designContest.data.bannerImageFullWidth}
                alt="banner"
                loading="lazy"
                style={{
                  objectFit: 'cover',
                  height: '100vh'
                }}
              />
            ) : (
              ""
            )}
          </div>
          {designContest?.data?.bannerImage ? (
            <div className={classes.shade}></div>
          ) : (
            ""
          )}
          <div className={classes.bannerText}>
            <Container maxWidth="lg">
              <Typography
                variant="h1"
                component="h1"
                className={classes.bannerTextTitle}
                style={{
                  color: designContest?.data?.bannerImage ? "white" : "black",
                  fontWeight: "bolder",
                }}
              >
                {designContest?.data?.title || "Title"}
              </Typography>
              <Typography
                className={classes.bannerTextSubTitle}
                style={{
                  color: designContest?.data?.bannerImage ? "white" : "black",
                }}
              >
                {designContest?.data?.description || "Subtitle"}
              </Typography>
              {Boolean(designContest.data) ? (
                <Link
                  to={
                    user ? "fashion-design-competition/submit" : "fashion-design-competition/login-popup"
                  }
                >
                  <Button variant="contained" className={classes.basicButton}>
                    Upload Desain
                  </Button>
                </Link>
              ) : (
                <Button
                  variant="contained"
                  className={classes.basicButton}
                  disabled
                >
                  Upload Desain
                </Button>
              )}
            </Container>
          </div>
          <div className={classes.copyright}>
            <span
              style={{
                color: designContest?.data?.bannerImage ? "white" : "black",
              }}
            >
              © Hak Cipta PT. Tokorame Anugerah Sejahtera - {year}
            </span>
          </div>
          <Link
            style={{
              position: "absolute",
              right: "25px",
              bottom: "25px",
            }}
            to="fashion-design-competition/help"
          >
            <Fab color="primary" aria-label="help">
              {/* {isAdmin ? (
                <Settings />
              ) : ( */}
                <img src={Help} alt="help" width="20px" />
              {/* )} */}
            </Fab>
          </Link>
        </div>

        {designs.length > 0 ? (
          <>
            <div className={classes.contentHeader}>
              <div>
                <Typography
                  variant="h4"
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: "2rem",
                  }}
                >
                  Desain yang sudah dikirimkan
                </Typography>
              </div>
              <div
                style={{
                  marginTop: "20px",
                }}
              >
                <AppBar
                  position="relative"
                  color="transparent"
                  style={{
                    boxShadow: "none",
                  }}
                >
                  <Tabs
                    value={pageIndex}
                    onChange={handleChangePage}
                    indicatorColor="primary"
                    textColor="primary"
                    variant={fullScreen ? "fullWidth" : "standard"}
                    aria-label="tabs"
                    centered
                  >
                    <Tab label="Semua" {...a11yProps(0)} />
                    <Tab label="Saya Vote" {...a11yProps(1)} />
                    <Tab label="Saya Sukai" {...a11yProps(2)} />
                  </Tabs>
                </AppBar>
              </div>
            </div>
            <Container maxWidth="xl" className={classes.container}>
              <SwipeableViews
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={pageIndex}
                onChangeIndex={handleChangePageIndex}
              >
                <TabPanel value={pageIndex} index={0} dir={theme.direction}>
                  {designs.map((item, index) => (
                    <Link
                      key={index}
                      onClick={(e) => {
                        if (upvotting || liking) {
                          e.preventDefault();
                        }
                        openDesign(index, "all");
                      }}
                      to="fashion-design-competition/design"
                      style={{
                        textDecoration: "none",
                        color: "grey",
                      }}
                    >
                      <div className={classes.images}>
                        <Container>
                          <div className={classes.image_header}>
                            <Grid container>
                              <Grid item xs={6}>
                                <div className={classes.image_header_profile}>
                                  <Avatar
                                    style={{
                                      color: "white",
                                      backgroundColor: "#5675D3",
                                    }}
                                  >
                                    {item?.owner?.avatar ? (
                                      <img
                                        src={item.owner.avatar}
                                        alt="avatar"
                                      />
                                    ) : (
                                      <Person
                                        style={{
                                          width: "30px",
                                          height: "30px",
                                        }}
                                      />
                                    )}
                                  </Avatar>
                                  <div
                                    className={classes.profile_capt}
                                    onClick={(e) => e.preventDefault()}
                                    style={{
                                      color: "#081328",
                                    }}
                                  >
                                    <Typography
                                      variant="h6"
                                      component="h6"
                                      className={classes.profile_name}
                                      style={{
                                        display: "flex",
                                      }}
                                    >
                                      {item?.title}
                                      {isAdmin ? (
                                        <span
                                          style={{
                                            marginLeft: "10px",
                                            display: "flex",
                                            alignItems: "center",
                                            color:
                                              item.status === "approved"
                                                ? "green"
                                                : "orange",
                                          }}
                                          onClick={(e) => {
                                            e.preventDefault();
                                            let mode = item.status === "pending" ? "approve" : "pending";
                                            handleApproval(item.id, mode);
                                          }}
                                        >
                                          {item.status === "approved" ? (
                                            <CheckCircleOutline />
                                          ) : (
                                            <PauseCircleOutline />
                                          )}
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                    </Typography>
                                    <Typography
                                      variant="h6"
                                      component="p"
                                      className={classes.profile_subdomain}
                                    >
                                      {item?.owner?.nama}
                                    </Typography>
                                  </div>
                                </div>
                              </Grid>
                              <Grid
                                item
                                xs={6}
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "right",
                                  alignItems: "center",
                                }}
                              >
                                <div>
                                  {(designContest?.data?.isVotable ||
                                    isAdmin) &&
                                  item.status === "approved" ? (
                                    <button
                                      disabled={upvotting}
                                      className={`${classes.upvote} ${
                                        item.isUpvoted || item.isLiked
                                          ? classes.active
                                          : ""
                                      }`}
                                      style={{
                                        ...(item.isUpvoted
                                          ? { color: "#5675D3" }
                                          : null),
                                        position: "relative",
                                        right: "0",
                                        top: "0",
                                        marginLeft: "5px",
                                        border: `1px solid ${
                                          item.isUpvoted ? "#5675D3" : "grey"
                                        }`,
                                      }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleUpvote(
                                          item.id,
                                          item.isUpvoted ? "down" : "up"
                                        );
                                      }}
                                      title="vote"
                                    >
                                      {upvotting && upvottingId === item.id ? (
                                        <CircularProgress size={18} />
                                      ) : (
                                        <HowToVote
                                          style={{
                                            width: "18px",
                                            height: "18px",
                                          }}
                                        />
                                      )}
                                    </button>
                                  ) : (
                                    ""
                                  )}
                                  {designContest?.data?.isLikable || isAdmin ? (
                                    <button
                                      disabled={liking}
                                      className={`${classes.upvote} ${
                                        item.isUpvoted || item.isLiked
                                          ? classes.active
                                          : ""
                                      }`}
                                      style={{
                                        ...(item.isLiked
                                          ? { color: "#5675D3" }
                                          : null),
                                        position: "relative",
                                        right: "0",
                                        top: "0",
                                        marginLeft: "5px",
                                        border: `1px solid ${
                                          item.isLiked ? "#5675D3" : "grey"
                                        }`,
                                      }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleLike(
                                          item.id,
                                          item.isLiked ? "down" : "up"
                                        );
                                      }}
                                      title="like"
                                    >
                                      {liking && likingId === item.id ? (
                                        <CircularProgress size={18} />
                                      ) : (
                                        <ThumbUp
                                          style={{
                                            width: "18px",
                                            height: "18px",
                                          }}
                                        />
                                      )}
                                    </button>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                        </Container>
                        <img src={item.images[0]} alt="images" loading="lazy" />

                        <div
                          className={`${classes.image_attr} ${
                            item.isUpvoted || item.isLiked ? classes.active : ""
                          }`}
                        >
                          {(designContest?.data?.isVotable || isAdmin) &&
                          item.status === "approved" ? (
                            <button
                              disabled={upvotting}
                              className={classes.upvote}
                              style={{
                                ...(item.isUpvoted
                                  ? { color: "#5675D3" }
                                  : null),
                                right: designContest?.data?.isLikable
                                  ? "72px"
                                  : "20px",
                              }}
                              onClick={(e) => {
                                e.preventDefault();
                                handleUpvote(
                                  item.id,
                                  item.isUpvoted ? "down" : "up"
                                );
                              }}
                              title="vote"
                            >
                              {upvotting && upvottingId === item.id ? (
                                <CircularProgress size={18} />
                              ) : (
                                <HowToVote
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                  }}
                                />
                              )}
                            </button>
                          ) : (
                            ""
                          )}

                          {designContest?.data?.isLikable || isAdmin ? (
                            <button
                              disabled={liking}
                              className={classes.upvote}
                              style={{
                                ...(item.isLiked ? { color: "#5675D3" } : null),
                                right: "50",
                              }}
                              onClick={(e) => {
                                e.preventDefault();
                                handleLike(
                                  item.id,
                                  item.isLiked ? "down" : "up"
                                );
                              }}
                              title="like"
                            >
                              {liking && likingId === item.id ? (
                                <CircularProgress size={18} />
                              ) : (
                                <ThumbUp
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                  }}
                                />
                              )}
                            </button>
                          ) : (
                            ""
                          )}

                          <div
                            className={classes.profile}
                            style={{
                              width: "calc(100% / 2)",
                            }}
                          >
                            <Avatar
                              style={{
                                color: "white",
                                backgroundColor: "#5675D3",
                              }}
                            >
                              {item?.owner?.avatar ? (
                                <img src={item.owner.avatar} alt="avatar" />
                              ) : (
                                <Person
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                  }}
                                />
                              )}
                            </Avatar>
                            <div
                              className={classes.profile_capt}
                              onClick={(e) => {
                                if (upvotting) {
                                  e.preventDefault();
                                }
                                openDesign(index);
                              }}
                            >
                              <Typography
                                variant="h6"
                                component="h6"
                                className={classes.profile_name}
                                style={{
                                  display: "flex",
                                }}
                              >
                                {item?.title}
                                {isAdmin ? (
                                  <span
                                    style={{
                                      marginLeft: "10px",
                                      display: "flex",
                                      alignItems: "center",
                                      color:
                                        item.status === "approved"
                                          ? "green"
                                          : "orange",
                                    }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      let mode = item.status === "pending" ? "approve" : "pending";
                                      handleApproval(item.id, mode);
                                    }}
                                  >
                                    {item.status === "approved" ? (
                                      <CheckCircleOutline />
                                    ) : (
                                      <PauseCircleOutline />
                                    )}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </Typography>
                              <Typography
                                variant="h6"
                                component="p"
                                className={classes.profile_subdomain}
                              >
                                {item?.owner?.nama}
                              </Typography>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  ))}
                </TabPanel>
                <TabPanel value={pageIndex} index={1} dir={theme.direction}>
                  {upvotedDesigns.map((item, index) => (
                    <Link
                      key={index}
                      onClick={(e) => {
                        if (upvotting || liking) {
                          e.preventDefault();
                        }
                        openDesign(index, "voted");
                      }}
                      to="fashion-design-competition/design"
                      style={{
                        textDecoration: "none",
                        color: "grey",
                      }}
                    >
                      <div className={classes.images}>
                        <Container>
                          <div className={classes.image_header}>
                            <Grid container>
                              <Grid item xs={6}>
                                <div className={classes.image_header_profile}>
                                  <Avatar
                                    style={{
                                      color: "white",
                                      backgroundColor: "#5675D3",
                                    }}
                                  >
                                    {item?.owner?.avatar ? (
                                      <img
                                        src={item.owner.avatar}
                                        alt="avatar"
                                      />
                                    ) : (
                                      <Person
                                        style={{
                                          width: "30px",
                                          height: "30px",
                                        }}
                                      />
                                    )}
                                  </Avatar>
                                  <div
                                    className={classes.profile_capt}
                                    onClick={(e) => e.preventDefault()}
                                    style={{
                                      color: "#081328",
                                    }}
                                  >
                                    <Typography
                                      variant="h6"
                                      component="h6"
                                      className={classes.profile_name}
                                    >
                                      {item?.title}
                                    </Typography>
                                    <Typography
                                      variant="h6"
                                      component="p"
                                      className={classes.profile_subdomain}
                                    >
                                      {item?.owner?.nama}
                                    </Typography>
                                  </div>
                                </div>
                              </Grid>
                              <Grid
                                item
                                xs={6}
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "right",
                                  alignItems: "center",
                                }}
                              >
                                <div>
                                  {(designContest?.data?.isVotable ||
                                    isAdmin) &&
                                  item.status === "approved" ? (
                                    <button
                                      disabled={upvotting}
                                      className={`${classes.upvote} ${
                                        item.isUpvoted || item.isLiked
                                          ? classes.active
                                          : ""
                                      }`}
                                      style={{
                                        ...(item.isUpvoted
                                          ? { color: "#5675D3" }
                                          : null),
                                        position: "relative",
                                        right: "0",
                                        top: "0",
                                        marginLeft: "5px",
                                        border: `1px solid ${
                                          item.isUpvoted ? "#5675D3" : "grey"
                                        }`,
                                      }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleUpvote(
                                          item.id,
                                          item.isUpvoted ? "down" : "up"
                                        );
                                      }}
                                      title="vote"
                                    >
                                      {upvotting && upvottingId === item.id ? (
                                        <CircularProgress size={18} />
                                      ) : (
                                        <HowToVote
                                          style={{
                                            width: "18px",
                                            height: "18px",
                                          }}
                                        />
                                      )}
                                    </button>
                                  ) : (
                                    ""
                                  )}
                                  {designContest?.data?.isLikable || isAdmin ? (
                                    <button
                                      disabled={liking}
                                      className={`${classes.upvote} ${
                                        item.isUpvoted || item.isLiked
                                          ? classes.active
                                          : ""
                                      }`}
                                      style={{
                                        ...(item.isLiked
                                          ? { color: "#5675D3" }
                                          : null),
                                        position: "relative",
                                        right: "0",
                                        top: "0",
                                        marginLeft: "5px",
                                        border: `1px solid ${
                                          item.isLiked ? "#5675D3" : "grey"
                                        }`,
                                      }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleLike(
                                          item.id,
                                          item.isLiked ? "down" : "up"
                                        );
                                      }}
                                      title="like"
                                    >
                                      {liking && likingId === item.id ? (
                                        <CircularProgress size={18} />
                                      ) : (
                                        <ThumbUp
                                          style={{
                                            width: "18px",
                                            height: "18px",
                                          }}
                                        />
                                      )}
                                    </button>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                        </Container>
                        <img src={item.images[0]} alt="images" loading="lazy" />

                        <div
                          className={`${classes.image_attr} ${
                            item.isUpvoted || item.isLiked ? classes.active : ""
                          }`}
                        >
                          {(designContest?.data?.isVotable || isAdmin) &&
                          item.status === "approved" ? (
                            <button
                              disabled={upvotting}
                              className={classes.upvote}
                              style={{
                                ...(item.isUpvoted
                                  ? { color: "#5675D3" }
                                  : null),
                                right: designContest?.data?.isLikable
                                  ? "72px"
                                  : "20px",
                              }}
                              onClick={(e) => {
                                e.preventDefault();
                                handleUpvote(
                                  item.id,
                                  item.isUpvoted ? "down" : "up"
                                );
                              }}
                              title="vote"
                            >
                              {upvotting && upvottingId === item.id ? (
                                <CircularProgress size={18} />
                              ) : (
                                <HowToVote
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                  }}
                                />
                              )}
                            </button>
                          ) : (
                            ""
                          )}

                          {designContest?.data?.isLikable || isAdmin ? (
                            <button
                              disabled={liking}
                              className={classes.upvote}
                              style={{
                                ...(item.isLiked ? { color: "#5675D3" } : null),
                                right: "50",
                              }}
                              onClick={(e) => {
                                e.preventDefault();
                                handleLike(
                                  item.id,
                                  item.isLiked ? "down" : "up"
                                );
                              }}
                              title="like"
                            >
                              {liking && likingId === item.id ? (
                                <CircularProgress size={18} />
                              ) : (
                                <ThumbUp
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                  }}
                                />
                              )}
                            </button>
                          ) : (
                            ""
                          )}

                          <div
                            className={classes.profile}
                            style={{
                              width: "calc(100% / 2)",
                            }}
                          >
                            <Avatar
                              style={{
                                color: "white",
                                backgroundColor: "#5675D3",
                              }}
                            >
                              {item?.owner?.avatar ? (
                                <img src={item.owner.avatar} alt="avatar" />
                              ) : (
                                <Person
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                  }}
                                />
                              )}
                            </Avatar>
                            <div
                              className={classes.profile_capt}
                              onClick={(e) => {
                                if (upvotting) {
                                  e.preventDefault();
                                }
                                openDesign(index);
                              }}
                            >
                              <Typography
                                variant="h6"
                                component="h6"
                                className={classes.profile_name}
                              >
                                {item?.title}
                              </Typography>
                              <Typography
                                variant="h6"
                                component="p"
                                className={classes.profile_subdomain}
                              >
                                {item?.owner?.nama}
                              </Typography>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  ))}
                </TabPanel>
                <TabPanel value={pageIndex} index={2} dir={theme.direction}>
                  {likedDesigns.map((item, index) => (
                    <Link
                      key={index}
                      onClick={(e) => {
                        if (upvotting || liking) {
                          e.preventDefault();
                        }
                        openDesign(index, "liked");
                      }}
                      to="fashion-design-competition/design"
                      style={{
                        textDecoration: "none",
                        color: "grey",
                      }}
                    >
                      <div className={classes.images}>
                        <Container>
                          <div className={classes.image_header}>
                            <Grid container>
                              <Grid item xs={6}>
                                <div className={classes.image_header_profile}>
                                  <Avatar
                                    style={{
                                      color: "white",
                                      backgroundColor: "#5675D3",
                                    }}
                                  >
                                    {item?.owner?.avatar ? (
                                      <img
                                        src={item.owner.avatar}
                                        alt="avatar"
                                      />
                                    ) : (
                                      <Person
                                        style={{
                                          width: "30px",
                                          height: "30px",
                                        }}
                                      />
                                    )}
                                  </Avatar>
                                  <div
                                    className={classes.profile_capt}
                                    onClick={(e) => e.preventDefault()}
                                    style={{
                                      color: "#081328",
                                    }}
                                  >
                                    <Typography
                                      variant="h6"
                                      component="h6"
                                      className={classes.profile_name}
                                    >
                                      {item?.title} asd
                                    </Typography>
                                    <Typography
                                      variant="h6"
                                      component="p"
                                      className={classes.profile_subdomain}
                                    >
                                      {item?.owner?.nama}
                                    </Typography>
                                  </div>
                                </div>
                              </Grid>
                              <Grid
                                item
                                xs={6}
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "right",
                                  alignItems: "center",
                                }}
                              >
                                <div>
                                  {(designContest?.data?.isVotable ||
                                    isAdmin) &&
                                  item.status === "approved" ? (
                                    <button
                                      disabled={upvotting}
                                      className={`${classes.upvote} ${
                                        item.isUpvoted || item.isLiked
                                          ? classes.active
                                          : ""
                                      }`}
                                      style={{
                                        ...(item.isUpvoted
                                          ? { color: "#5675D3" }
                                          : null),
                                        position: "relative",
                                        right: "0",
                                        top: "0",
                                        marginLeft: "5px",
                                        border: `1px solid ${
                                          item.isUpvoted ? "#5675D3" : "grey"
                                        }`,
                                      }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleUpvote(
                                          item.id,
                                          item.isUpvoted ? "down" : "up"
                                        );
                                      }}
                                      title="vote"
                                    >
                                      {upvotting && upvottingId === item.id ? (
                                        <CircularProgress size={18} />
                                      ) : (
                                        <HowToVote
                                          style={{
                                            width: "18px",
                                            height: "18px",
                                          }}
                                        />
                                      )}
                                    </button>
                                  ) : (
                                    ""
                                  )}
                                  {designContest?.data?.isLikable || isAdmin ? (
                                    <button
                                      disabled={liking}
                                      className={`${classes.upvote} ${
                                        item.isUpvoted || item.isLiked
                                          ? classes.active
                                          : ""
                                      }`}
                                      style={{
                                        ...(item.isLiked
                                          ? { color: "#5675D3" }
                                          : null),
                                        position: "relative",
                                        right: "0",
                                        top: "0",
                                        marginLeft: "5px",
                                        border: `1px solid ${
                                          item.isLiked ? "#5675D3" : "grey"
                                        }`,
                                      }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleLike(
                                          item.id,
                                          item.isLiked ? "down" : "up"
                                        );
                                      }}
                                      title="like"
                                    >
                                      {liking && likingId === item.id ? (
                                        <CircularProgress size={18} />
                                      ) : (
                                        <ThumbUp
                                          style={{
                                            width: "18px",
                                            height: "18px",
                                          }}
                                        />
                                      )}
                                    </button>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                        </Container>
                        <img src={item.images[0]} alt="images" loading="lazy" />

                        <div
                          className={`${classes.image_attr} ${
                            item.isUpvoted || item.isLiked ? classes.active : ""
                          }`}
                        >
                          {(designContest?.data?.isVotable || isAdmin) &&
                          item.status === "approved" ? (
                            <button
                              disabled={upvotting}
                              className={classes.upvote}
                              style={{
                                ...(item.isUpvoted
                                  ? { color: "#5675D3" }
                                  : null),
                                right: designContest?.data?.isLikable
                                  ? "72px"
                                  : "20px",
                              }}
                              onClick={(e) => {
                                e.preventDefault();
                                handleUpvote(
                                  item.id,
                                  item.isUpvoted ? "down" : "up"
                                );
                              }}
                              title="vote"
                            >
                              {upvotting && upvottingId === item.id ? (
                                <CircularProgress size={18} />
                              ) : (
                                <HowToVote
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                  }}
                                />
                              )}
                            </button>
                          ) : (
                            ""
                          )}

                          {designContest?.data?.isLikable || isAdmin ? (
                            <button
                              disabled={liking}
                              className={classes.upvote}
                              style={{
                                ...(item.isLiked ? { color: "#5675D3" } : null),
                                right: "50",
                              }}
                              onClick={(e) => {
                                e.preventDefault();
                                handleLike(
                                  item.id,
                                  item.isLiked ? "down" : "up"
                                );
                              }}
                              title="like"
                            >
                              {liking && likingId === item.id ? (
                                <CircularProgress size={18} />
                              ) : (
                                <ThumbUp
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                  }}
                                />
                              )}
                            </button>
                          ) : (
                            ""
                          )}

                          <div
                            className={classes.profile}
                            style={{
                              width: "calc(100% / 2)",
                            }}
                          >
                            <Avatar
                              style={{
                                color: "white",
                                backgroundColor: "#5675D3",
                              }}
                            >
                              {item?.owner?.avatar ? (
                                <img src={item.owner.avatar} alt="avatar" />
                              ) : (
                                <Person
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                  }}
                                />
                              )}
                            </Avatar>
                            <div
                              className={classes.profile_capt}
                              onClick={(e) => {
                                if (upvotting) {
                                  e.preventDefault();
                                }
                                openDesign(index);
                              }}
                            >
                              <Typography
                                variant="h6"
                                component="h6"
                                className={classes.profile_name}
                              >
                                {item?.title}
                              </Typography>
                              <Typography
                                variant="h6"
                                component="p"
                                className={classes.profile_subdomain}
                              >
                                {item?.owner?.nama}
                              </Typography>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  ))}
                </TabPanel>
              </SwipeableViews>
            </Container>
          </>
        ) : (
          ""
        )}
      </div>

      <Route
        path="/fashion-design-competition/login-popup"
        children={({ match }) => {
          return (
            <Dialog
              fullScreen={isMobile || fullScreen}
              open={Boolean(match)}
              onClose={history.goBack}
              scroll="body"
              keepMounted
              TransitionComponent={Transition}
            >
              <LoginPopup path="/fashion-design-competition" pathName="design_contest" />
            </Dialog>
          );
        }}
      />

      <Route
        path="/fashion-design-competition/help"
        children={({ match }) => {
          return (
            <Dialog
              fullScreen={isMobile || fullScreen}
              open={Boolean(match)}
              onClose={history.goBack}
              maxWidth="md"
              fullWidth
            >
              <HelpPopup url={designContest?.data?.bannerImageSmall} />
            </Dialog>
          );
        }}
      />

      <Route
        path="/fashion-design-competition/design"
        children={({ match }) => {
          return (
            <Dialog
              fullScreen={fullScreen}
              open={Boolean(match)}
              onClose={history.goBack}
              aria-labelledby="responsive-dialog-title"
              maxWidth="md"
              fullWidth
              TransitionComponent={TransitionSlideUp}
            >
              <DesignDialog
                design={openedDesign}
                handleUpvote={handleUpvote}
                handleLike={handleLike}
                handleApproval={handleApproval}
                isAdmin={isAdmin}
              />
            </Dialog>
          );
        }}
      />
      <Route
        path="/fashion-design-competition/submit"
        children={({ match }) => {
          return (
            <Dialog
              open={Boolean(match)}
              onClose={() => {
                if (user) {
                  if (
                    window.confirm(
                      "Apakah anda yakin ingin menutup form ini? informasi yang anda masukkan akan hilang."
                    )
                  ) {
                    return history.goBack();
                  }
                  return;
                }
                return history.goBack();
              }}
              fullWidth={true}
              maxWidth={"lg"}
              scroll={"paper"}
              aria-labelledby="scroll-dialog-title"
              fullScreen={fullScreen}
            >
              <SubmitDialog
                designContest={designContest}
                isOpen={Boolean(match && user)}
                user={user}
                profile={profile}
              />
            </Dialog>
          );
        }}
      />
    </>
  );
};

export default DesignContest;
